import { render, staticRenderFns } from "./BtnWrapper.vue?vue&type=template&id=1ad5caee"
import script from "./BtnWrapper.vue?vue&type=script&lang=js"
export * from "./BtnWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports